import { render } from "./taskCard.vue?vue&type=template&id=3c44f64a"
import script from "./taskCard.vue?vue&type=script&lang=js"
export * from "./taskCard.vue?vue&type=script&lang=js"

import "./taskCard.vue?vue&type=style&index=0&id=3c44f64a&lang=less"

import exportComponent from "D:\\新git项目\\xbot-ui\\xbot-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__